// 场景数据版本迁移。加载 project.data 或 default_data 后、loadScene 前调 migrateSceneData。
// 防场景迭代（加/删/改字段）破坏已保存的旧项目数据。
// 跨场景关注点，保留集中分发；各场景真实迁移逻辑未来可下沉到各自模块。
import type { SceneData, SceneType } from '../../api/types'

// 各场景当前数据版本。数据结构变更时 bump（1→2→3...），并在下方加迁移块。
const CURRENT_VERSION: Partial<Record<SceneType, number>> = {
  'chart-race': 1,
  'ranking-reveal': 1,
  'vs-comparison': 1,
  'quote-card': 1,
  'map-trajectory': 1,
  'news-brief': 1,
  'chat-story': 1,
  'year-wrapped': 1,
}

/**
 * migrateSceneData 把旧版本场景数据迁移到当前版本。
 *
 * 用法：loadScene 前调 migrateSceneData(sceneId, data)。
 * 旧数据无 _version → 视为 version 0 → 走全部迁移块 → 设为 target。
 *
 * 迁移块示例（未来 chart-race 加 valuePrefix 后 bump 到 2）：
 *   if (id === 'chart-race' && v < 2) {
 *     m.valuePrefix = m.valuePrefix ?? ''
 *     m.valueSuffix = m.valueSuffix ?? ''
 *   }
 */
export function migrateSceneData(sceneId: string, data: SceneData): SceneData {
  const target = CURRENT_VERSION[sceneId as SceneType] ?? 1
  const v = (data as any)._version ?? 0

  if (v >= target) return data // 已是当前版本

  const m: any = { ...data }

  // === 迁移逻辑（按 sceneId + 版本号）===
  // 当前所有场景 version 1（初始），无历史迁移。
  // 改场景数据结构时：
  //   1. bump CURRENT_VERSION[sceneId]（1→2）
  //   2. 这里加 if (sceneId === 'xxx' && v < 2) { ... 补字段/改名 ... }

  ;(m as any)._version = target
  return m as SceneData
}
